/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import Types from '../constants/actionTypes';

const initialState = {
  showNotification: false,
  notificationType: '',
  message: '',
  dragInProgress: false,
  hoverBackground: true
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.HIDE_NOTIFICATION:
      return { ...state, showNotification: false };
    case Types.APPLICATION_ERROR:
      return {
        ...state,
        showNotification: true,
        notificationType: 'error',
        message: action.message
      };
    case Types.SUCCESS_ACTION:
      return {
        ...state,
        showNotification: true,
        notificationType: 'success',
        message: action.message
      };
    case Types.UNAUTHORIZED_ERROR:
      return {
        ...state,
        showNotification: true,
        notificationType: 'unauthorized',
        message: action.message
      };
    case Types.SERVER_ERROR:
      return {
        ...state,
        showNotification: true,
        notificationType: 'lostConnection',
        message: action.message
      };
    case Types.DRAG_STATUS:
      return { ...state, dragInProgress: action.status };
    case Types.SET_HOVER_BACKGROUND:
      return { ...state, hoverBackground: action.hoverBackground };
    default:
      return state;
  }
};

export default notificationReducer;
